import React from 'react';
import InspectionPhotoField from './InspectionPhotoField';

function RiskQuestionRow({
  question,
  answer,
  riskLevel,
  location,
  mitigation,
  followUp,
  response,
  notes,
  readOnly,
  onRiskLevelChange,
  onLocationChange,
  onMitigationChange,
  onFollowUpChange,
  onResponseChange,
  onNotesChange,
  onUploadPhoto,
  onDeletePhoto,
  onCreateServiceRequest,
}) {
  return (
    <div className="inspection-question-row inspection-question-row--risk">
      <div className="inspection-q-question">{question.questionText}</div>

      <div className="inspection-q-risk">
        <label className="inspection-q-field-label d-md-none">Risk</label>
        <select
          className="form-select form-select-sm"
          value={riskLevel || ''}
          onChange={(e) => onRiskLevelChange(question.id, e.target.value)}
          disabled={readOnly}
        >
          <option value="">—</option>
          <option value="low">Low</option>
          <option value="medium">Medium</option>
          <option value="high">High</option>
        </select>
      </div>

      <div className="inspection-q-location">
        <label className="inspection-q-field-label d-md-none">Location</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={location ?? ''}
          onChange={(e) => onLocationChange(question.id, e.target.value)}
          disabled={readOnly}
        />
      </div>

      <div className="inspection-q-mitigation">
        <label className="inspection-q-field-label d-md-none">Mitigation</label>
        <select
          className="form-select form-select-sm"
          value={mitigation || ''}
          onChange={(e) => onMitigationChange(question.id, e.target.value)}
          disabled={readOnly}
        >
          <option value="">—</option>
          <option value="Y">Y</option>
          <option value="N">N</option>
        </select>
      </div>

      <div className="inspection-q-followup">
        <label className="inspection-q-field-label d-md-none">Follow-up</label>
        <select
          className="form-select form-select-sm"
          value={followUp || ''}
          onChange={(e) => onFollowUpChange(question.id, e.target.value)}
          disabled={readOnly}
        >
          <option value="">—</option>
          <option value="Y">Y</option>
          <option value="N">N</option>
        </select>
      </div>

      <div className="inspection-q-response">
        <label className="inspection-q-field-label d-md-none">Response</label>
        <select
          className="form-select form-select-sm"
          value={response || ''}
          onChange={(e) => onResponseChange(question.id, e.target.value)}
          disabled={readOnly}
        >
          <option value="">—</option>
          <option value="pass">Pass</option>
          <option value="fail">Fail</option>
          <option value="na">NA</option>
        </select>
      </div>

      <div className="inspection-q-notes">
        <label className="inspection-q-field-label d-md-none">Notes</label>
        <textarea
          className="form-control form-control-sm"
          rows={2}
          value={notes ?? ''}
          onChange={(e) => onNotesChange(question.id, e.target.value)}
          disabled={readOnly}
        />
      </div>

      <div className="inspection-q-actions">
        <InspectionPhotoField
          answer={answer}
          readOnly={readOnly}
          onUpload={onUploadPhoto}
          onDelete={onDeletePhoto}
        />
        <div className="inspection-q-sr">
          {!readOnly && (
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={() => onCreateServiceRequest(question)}
            >
              Create SR
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default RiskQuestionRow;
